"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPassengersToEmailString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const transformChildSeatTypeToString_1 = require("./transformChildSeatTypeToString");
const transformDateToString_1 = require("./transformDateToString");
const transformLuggageTypeToString_1 = require("./transformLuggageTypeToString");
const transformPassengerTypeToString_1 = require("./transformPassengerTypeToString");
// for create order email !!! dont change for anything else
function transformPassengersToEmailString(passengers) {
    const passengersString = `${passengers
        .map((p, index) => {
        const lugagge = (luggage) => luggage.map((l) => (0, transformLuggageTypeToString_1.transformLuggageTypeToString)(l)).join(", ");
        const result = [
            `${index + 1}) ${p.type === legacy_enums_1.PassengerType.Child ? "<strong>" : ""}${(0, transformPassengerTypeToString_1.transformPassengerTypeToString)(p.type)}${p.type === legacy_enums_1.PassengerType.Child ? "</strong>" : ""}`,
        ];
        if (!(0, utils_1.isUndefinedOrNull)(p.firstName)) {
            result.push(`\t first name: ${p.firstName}`);
        }
        if (!(0, utils_1.isUndefinedOrNull)(p.lastName)) {
            result.push(`\t last name: ${p.lastName}`);
        }
        if (!(0, utils_1.isUndefinedOrNull)(p.email)) {
            result.push(`\t email: ${p.email}`);
        }
        if (!(0, utils_1.isUndefinedOrNull)(p.phoneNumber) && p.phoneNumber !== "") {
            result.push(`\t phone: ${p.phoneNumber}`);
        }
        if (!(0, utils_1.isUndefinedOrNull)(p.childSeatType)) {
            result.push(`\t childseat: ${(0, transformChildSeatTypeToString_1.transformChildSeatTypeToString)(p.childSeatType)}`);
        }
        if (!(0, utils_1.isUndefinedOrNull)(p.birthdayAt)) {
            result.push(`\t birthday: ${(0, transformDateToString_1.transformDateToString)(p.birthdayAt)}`);
        }
        if (p.luggage.length > 2) {
            result.push(`\t extra luggage: ${lugagge(p.luggage.slice(2))}`);
        }
        return result.join("<br>");
    })
        .join("<br>")}<br>`;
    return passengersString;
}
exports.transformPassengersToEmailString = transformPassengersToEmailString;
//# sourceMappingURL=transformPassengersToEmailString.js.map